import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChronologyEvent } from '../../shared/timeline/chronology/ChronologyEvent';

@Component({
  standalone: false,
  selector: 'app-patient-history',
  templateUrl: './patient-history.component.html',
  styleUrls: ['./patient-history.component.scss']
})
export class PatientHistoryComponent
{
  @Input() public entries: ChronologyEvent[];
  @Output() public scrolled: EventEmitter<any> = new EventEmitter();

  public selector = '.history-container';

  public onScroll(): void
  {
    this.scrolled.emit();
  }
}
